<template>
  <div class="ridingMapWrapper">
    <div v-if="loading" class="mapLoading">Loading map...</div>
    <template v-else>
      <div class="mapControls">
        <button @click="zoomIn">+</button>
        <button @click="zoomOut">−</button>
        <button @click="resetView">Reset</button>
      </div>
      <div
        class="mapViewport"
        @wheel.prevent="onWheel"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
        @mouseleave="onMouseUp"
      >
        <div
          class="mapCanvas"
          :style="{
            transform: `translate(${translateX}px, ${translateY}px) scale(${scale})`,
          }"
          v-html="renderedSvg"
        ></div>
      </div>
    </template>
  </div>
</template>

<script>
const MIN_SCALE = 0.5;
const MAX_SCALE = 10;
const ZOOM_STEP = 0.2;

export default {
  name: "RidingMap",
  props: {
    ridingColors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      svgDoc: null,
      renderedSvg: "",
      loading: true,
      scale: 1,
      translateX: 0,
      translateY: 0,
      dragging: false,
      dragStart: { x: 0, y: 0 },
    };
  },
  watch: {
    ridingColors: {
      deep: true,
      handler() {
        this.applyColors();
      },
    },
  },
  async mounted() {
    await this.loadSvg();
    this.applyColors();
    this.loading = false;
  },
  methods: {
    async loadSvg() {
      const url = require("../../assets/RidingMap.svg");
      const response = await fetch(url);
      const svgText = await response.text();
      const parser = new DOMParser();
      this.svgDoc = parser.parseFromString(svgText, "image/svg+xml");
    },
    applyColors() {
      if (!this.svgDoc) return;
      const paths = this.svgDoc.querySelectorAll("[tagname]");
      let matched = 0;
      paths.forEach((path) => {
        const name = path.getAttribute("tagname");
        const color = this.ridingColors[name];
        if (this.ridingColors[name]) matched++;
        path.style.fill = color;
      });
      console.log(
        `[RidingMap] applyColors: ${paths.length} paths, ${matched} colored`,
      );
      const serializer = new XMLSerializer();
      this.renderedSvg = serializer.serializeToString(this.svgDoc);
    },
    zoomIn() {
      this.scale = Math.min(
        MAX_SCALE,
        parseFloat((this.scale + ZOOM_STEP).toFixed(2)),
      );
    },
    zoomOut() {
      this.scale = Math.max(
        MIN_SCALE,
        parseFloat((this.scale - ZOOM_STEP).toFixed(2)),
      );
    },
    resetView() {
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
    },
    onWheel(e) {
      const delta = e.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP;
      this.scale = Math.min(
        MAX_SCALE,
        Math.max(MIN_SCALE, parseFloat((this.scale + delta).toFixed(2))),
      );
    },
    onMouseDown(e) {
      this.dragging = true;
      this.dragStart = {
        x: e.clientX - this.translateX,
        y: e.clientY - this.translateY,
      };
    },
    onMouseMove(e) {
      if (!this.dragging) return;
      this.translateX = e.clientX - this.dragStart.x;
      this.translateY = e.clientY - this.dragStart.y;
    },
    onMouseUp() {
      this.dragging = false;
    },
  },
};
</script>

<style scoped>
.ridingMapWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mapLoading {
  text-align: center;
  padding: 40px;
  color: #666;
}
.mapControls {
  display: flex;
  gap: 6px;
}
.mapControls button {
  padding: 4px 12px;
  font-size: 16px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.mapControls button:hover {
  background: #f0f0f0;
}
.mapViewport {
  width: 100%;
  overflow: hidden;
  cursor: grab;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  height: 600px;
}
.mapViewport:active {
  cursor: grabbing;
}
.mapCanvas {
  transform-origin: top left;
  width: 100%;
}
</style>
